import { render } from "./BuildBundleStart.vue?vue&type=template&id=ec1649d6&scoped=true"
import script from "./BuildBundleStart.vue?vue&type=script&lang=js"
export * from "./BuildBundleStart.vue?vue&type=script&lang=js"

import "./BuildBundleStart.vue?vue&type=style&index=0&id=ec1649d6&scoped=true&lang=css"
import "./BuildBundleStart.vue?vue&type=style&index=1&id=ec1649d6&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec1649d6"]])

export default __exports__